import { EMAIL_REGEX, PASSWORD_REGEX } from "../constants";
import * as yup from "yup";

export const CreateUserSchema = yup.object({
  firstname: yup
    .string()
    .required(`First name is required`),
  middlename: yup
    .string(),
  lastname: yup
    .string()
    .required(`Last name is required`),
  email: yup
    .string()
    .email(`Please enter a valid email`)
    .required(`Email is required`)
    .test('EmailVerification', `Please enter a valid email`, (val) => (EMAIL_REGEX.test(val)), ),
  reinvestigations: yup.boolean(),
  outreach: yup.boolean(),
  pcc_outreach: yup.boolean(),
  default_view: yup.string(),
  password: yup
    .string()
    .when({
      is: (val:string) =>  val.length > 0,
      then: (schema)  => schema.test('PasswordValidation',
        `Password should contain <ul><li> Length should be 10,</li>
        <li> must contain at least 1 lowercase letter,</li>
        <li> must contain at least 1 uppercase letter,</li>
        <li> and 1 number</li>
        <li> Can contain special character.</li></ul>`,
        (val) => val ? PASSWORD_REGEX.test(val) : false,
      ) ,
    }),
  password_confirmation: yup
    .string()
    .when({
      is: (val:string) =>  val.length > 0,
      then: (schema)  =>  schema
      .min(10, `Password should be at least 10 characters`)
      .oneOf([yup.ref('password'), ''], 'Passwords should be same'),
    })
});